import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import IntakeForm from './pages/IntakeForm';
import VideoTraining from './pages/VideoTraining';
import Quiz from './pages/Quiz';
import Acknowledgment from './pages/Acknowledgment';
import Completion from './pages/Completion';
import Admin from './pages/Admin';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

const SESSION_KEY = 'hipaa_training_session';

function App() {
  const [userData, setUserData]             = useState(null);
  const [trainingData, setTrainingData]     = useState(null);
  const [quizData, setQuizData]             = useState(null);
  const [completionData, setCompletionData] = useState(null);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(SESSION_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.userData)       setUserData(parsed.userData);
        if (parsed.trainingData)   setTrainingData(parsed.trainingData);
        if (parsed.quizData)       setQuizData(parsed.quizData);
        if (parsed.completionData) setCompletionData(parsed.completionData);
      }
    } catch (_) {}
  }, []);

  const saveSession = (update) => {
    try {
      const current = JSON.parse(localStorage.getItem(SESSION_KEY) || '{}');
      localStorage.setItem(SESSION_KEY, JSON.stringify({ ...current, ...update }));
    } catch (_) {}
  };

  const handleFormSubmit = (data) => {
    setUserData(data);
    saveSession({ userData: data });
  };

  const handleTrainingComplete = (data) => {
    setTrainingData(data);
    saveSession({ trainingData: data });
  };

  const handleQuizComplete = (data) => {
    setQuizData(data);
    saveSession({ quizData: data });
  };

  const handleAcknowledgmentComplete = (data) => {
    setCompletionData(data);
    saveSession({ completionData: data });
  };

  const handleReset = () => {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem('hipaa_video_progress');
    setUserData(null);
    setTrainingData(null);
    setQuizData(null);
    setCompletionData(null);
  };

  return (
    <Router>
      <div className="app-wrapper">
        <Header />
        <main className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                completionData ? <Navigate to="/completion" replace /> :
                quizData       ? <Navigate to="/acknowledgment" replace /> :
                trainingData   ? <Navigate to="/quiz" replace /> :
                userData       ? <Navigate to="/training" replace /> :
                <IntakeForm onSubmit={handleFormSubmit} />
              }
            />
            <Route
              path="/training"
              element={
                completionData ? <Navigate to="/completion" replace /> :
                quizData       ? <Navigate to="/acknowledgment" replace /> :
                trainingData   ? <Navigate to="/quiz" replace /> :
                userData       ? <VideoTraining userData={userData} onComplete={handleTrainingComplete} /> :
                <Navigate to="/" replace />
              }
            />
            <Route
              path="/quiz"
              element={
                completionData ? <Navigate to="/completion" replace /> :
                quizData       ? <Navigate to="/acknowledgment" replace /> :
                trainingData && userData ? <Quiz userData={userData} onComplete={handleQuizComplete} /> :
                <Navigate to="/" replace />
              }
            />
            <Route
              path="/acknowledgment"
              element={
                completionData ? <Navigate to="/completion" replace /> :
                quizData && userData ? (
                  <Acknowledgment userData={userData} onComplete={handleAcknowledgmentComplete} />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route
              path="/completion"
              element={
                completionData && userData ? (
                  <Completion
                    userData={userData}
                    completionData={{ ...trainingData, ...quizData, ...completionData }}
                    onReset={handleReset}
                  />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
